import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import TourTags from "./tourTags"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import TourPrice from "./tourPrice"
import { Lang, LangEnum } from "../utils/lang"
import { EnergyLevel } from "../utils/enums"

const TourCard = ({blok}) => {
  // console.log(blok)
  if (!blok.content) return null;

  const content = typeof blok.content === 'string' ? JSON.parse(blok.content) : blok.content;
  const bannerBgImage = content.bannerBgImage?.filename ? content.bannerBgImage : null;
  // console.log(bannerBgImage)
  const lang = Lang()

  return (
    <a href={`/${blok.full_slug}`} className="min-h-[400px] cursor-pointer" {...storyblokEditable(blok)} >
      <img className="w-full h-[200px] rounded object-cover" alt={bannerBgImage?.alt} 
      loading="lazy" src={`${bannerBgImage?.filename}/m/0x300`} />
      <div className="px-3">
        <div className="text-sm mt-4 mb-2">{content.tourSubHeading}</div>
        <div className="font-serif font-bold mb-4">{content.tourTitle}</div>
        <TourTags blok={content} />
        <div className="price font-bold my-3"><TourPrice currency={content.currency} price={content.price} pricingBasis={content.pricingBasis} /></div> 
        {
        lang === LangEnum.EN &&
        <div className="details text-sm max-w-[500px]">
          <dl className="grid grid-cols-[auto,1fr]">
            <dt className="text-right font-bold p-2 border-black border-r ">Type</dt>
            <dd className="p-2 capitalize">{content.typeOfTour} Tour</dd>
            <dt className="text-right font-bold p-2 border-black border-r border-y bg-gray-100">Duration</dt>
            <dd className="p-2 border-black border-y bg-gray-100">{content.durationDays} {content.durationDays <= 1 ? 'Day' : 'Days'}{content.durationNights && `, ${content.durationNights} ${content.durationNights <= 1 ? 'Night' : 'Nights'}`}</dd>
            <dt className="text-right font-bold p-2 border-black border-r">In-Short</dt>
            <dd className="p-2">{content.overviewHeading}</dd>
            {content.prefecture && typeof(content.prefecture[0]) === 'object' &&
            <>
              <dt className="text-right font-bold p-2 border-black border-r border-t bg-gray-100">Destinations</dt>
              <dd className="p-2 border-black border-t bg-gray-100">{content.prefecture?.map((p) => p.name).join(', ')}</dd> 
            </>}
            {content.prefecture?.length === 0 && content.destination?.length > 0 &&
            <>
              <dt className="text-right font-bold p-2 border-black border-r border-t bg-gray-100">Destinations</dt>
              <dd className="p-2 border-black border-t bg-gray-100">{content.destination?.map((d) => d).join(', ')}</dd> 
            </>}
            { content.energyLevel &&
            <>
              <dt className="text-right font-bold p-2 border-black border-r border-t">Activity Level</dt>
              <dd className="p-2 border-black border-t">{EnergyLevel[content.energyLevel]}</dd>
            </>}
          </dl>
        </div>
        }
      </div>
    </a>
  )

}

export default TourCard
